export const firstOrNull = <T>(items: T[]): T | null => items?.[0] ?? null;
